import { combineReducers } from 'redux';

import Modal, { StateRedux as ModalStateContract } from './modal';

export interface ReducerContract {
  Modal: ModalStateContract;
}

export interface Action<Types, Payload> {
  type: Types;
  payload?: Payload;
}

export default combineReducers<ReducerContract>({
  Modal,
});
